import { FC } from 'react';
import {
    Button
} from '@mui/material';

export const ViewCampaignInCoreButton: FC<{
    coreCampaignId: string;
}> = ({ coreCampaignId }) => {
    const coreCampaignLink = process.env.REACT_APP_CORE_CAMPAIGN_LINK;
    return (
        <Button
            className='view-in-core-button'
            variant="outlined"
            target="_blank"
            disabled={!coreCampaignId}
            href={`${coreCampaignLink}${coreCampaignId}`}
        >
            View Campaign in Core
        </Button>
    )
};
